import { Directive, OnInit, inject, input } from '@angular/core';

import { GridApi, GridReadyEvent } from 'ag-grid-enterprise';

import { CamBaseComponent } from '@camelot/utils';

import { CamGridData } from '../models/grid-data';
import { CamGridDataService } from '../services/grid-data.service';

@Directive()
export abstract class AbstractGridComponent<T extends { id: string }> extends CamBaseComponent implements OnInit {
  gridId = input.required<string>();

  protected _grid!: CamGridData<T>;
  protected _createGrid = true;

  private readonly _dataService = inject<CamGridDataService<T>>(CamGridDataService);

  get filteredData$() {
    return this._grid.filteredData$;
  }

  ngOnInit() {
    this._grid = this._dataService.get(this.gridId(), this._createGrid);
  }

  public onGridReady(event: GridReadyEvent<unknown>) {
    this._grid.setApi(event.api as unknown as GridApi<T>);
  }
}
